import activeBranchesReducer from './activeBranchesReducer';
import repositoriesReducer from './repositoriesReducer';
import repositoryReducer from './repositoryReducer';
import userReducer from './userReducer';
export default {
    activeBranches: activeBranchesReducer,
    repositories: repositoriesReducer,
    repository: repositoryReducer,
    user: userReducer,
};
